import { Handle, NodeProps, Position } from 'reactflow';
import { MultipleInput, MultipleInputProps } from '@evoach/ui-components';
import { useIntl } from 'react-intl';

import { translateKey, useGlobalStyles } from './base.node';

/*
  MultipleInputSingle react-flow node for module builder graph canvas
*/

export const MultipleInputSingleNode: React.FC<NodeProps<any>> = (
  nodeProps: any
) => {
  const classes = useGlobalStyles();
  const intl = useIntl();
  const payload = nodeProps.data.state.entry[0].payload;
  let texts: string[] = payload.placeholderTexts;
  if (!texts) {
    texts = ['TODO transl keys'];
  }

  const props: MultipleInputProps = {
    saveResultTo: payload.saveResultTo,
    placeholderTexts: texts.map((label: string) => {
      return translateKey(intl, label);
    }),
    buttonText: translateKey(intl, payload.buttonText),
    presetValues: [''],
  };

  return (
    <>
      <Handle
        type="target"
        position={Position.Top}
        isConnectable={nodeProps.isConnectable}
        className={classes['react-flow__handle']}
      />
      <div
        className={nodeProps.selected ? classes.selectStyletrue : classes.root}
      >
        <MultipleInput {...props} />
      </div>
      <Handle
        type="source"
        position={Position.Bottom}
        id="nohandle"
        isConnectable={nodeProps.isConnectable}
        className={classes['react-flow__handle']}
      />
    </>
  );
};
